import { render, staticRenderFns } from "./CadastrarRepresentanteTerritorial.vue?vue&type=template&id=3518a916"
import script from "./CadastrarRepresentanteTerritorial.vue?vue&type=script&lang=js"
export * from "./CadastrarRepresentanteTerritorial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports